/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

import moment from "moment";
import { ROUND } from '@formulajs/formulajs'

import { MessageCenter } from 'utils';

import { modalityHandler } from '../../modality/index';
import { creditAnalysisInfoHandler } from "../../creditAnalysisInfo/index";

function handleInitialAdjustments({
  questionnaire
}) {
  return questionnaire.map(question => {
    if (question.idQuestion === 1686) {
      const qst = questionnaire.find(qst => qst.idQuestion === 1685);
      if (qst?.answer) {
        question.behaviorObject.fieldMinValue = 0;
      }
    }

    if (question.idQuestion === 1680 && question?.childrenQuestions?.length) {
      const situationQst = question.childrenQuestions.find(qst => qst.idQuestion === 1687);
      const claimCompensatedQst = questionnaire.find(qst => qst.idQuestion === 1667);

      if ([7283, 7354].includes(situationQst?.idAnswerOption)) {
        question.disabled = true;
        question.childrenQuestions.map(qst => {
          qst.disabled = true;
          return qst;
        });
      } else if (situationQst?.idAnswerOption == 7284) {
        question.disabled = true;
        question.childrenQuestions.map(qst => {
          if (qst.idQuestion != 1687) {
            qst.disabled = true;
          } else if (claimCompensatedQst?.idAnswerOption === 7273) {
            qst.disabled = true;
          }
          return qst;
        });
      }
    }

    return question;
  })
}

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  setCanUpdateBorrowerSRO,
  globalQuestionnaire,
  economicGroup,
  updateIsLoadingStatus,
  token,
  shareCapital,
  limits,
  setLimits,
  modalitiesFeesData,
  scoreInformationData,
  modalities,
  setModalities,
  setQuestionnaireAnswersToDelete,
  questionnaireAnswersToDelete,
  useGetBorrowersInformationByLegalPersonIdsRequest,
}) {
  let saveFilteredQuestionnaire = false;

  const mc = new MessageCenter();

  if ([1680].includes(question.idQuestion) && value && setCanUpdateBorrowerSRO) {
    setCanUpdateBorrowerSRO(true);
  }

  if (question.idQuestion === 1686) {
    if (value < question.answer) {
      mc.error('Data informada é inferior a data atual de fim de vigência');
    } else {
      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion === 1687 && qst.answer === "Prorrogado ") {
          qst.behaviorObject.fieldMinValue = 0;
          const date = moment(question.answer);
          const dataExtension = date.add(45, 'days');
          const dataExtensionFormat = dataExtension.format('YYYY-MM-DD');
          if (value > dataExtensionFormat) {
            mc.error('Data informada é superior ao período de 45 dias autorizados.');
          }
        }
      })
    }
  }

  if (question.idQuestion === 1687) {
    saveFilteredQuestionnaire = true;
    questionnaireUpdated = questionnaireUpdated.map(qst => {
      qst.disabled = ![7286, 7285].includes(value?.idAnswerOption);
      if (qst.idQuestion === 1687 && ([7284].includes(value?.idAnswerOption) || !value?.idAnswerOption)) {
        qst.disabled = false;
      }
      return qst;
    });

    if (value.idAnswerOption == 7285) {
      let limitExtension;
      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion == 1791) {
          if (!qst.answer) qst.answer = 0;
          if (qst.answer < 2) {
            const newValue = qst.answer = Number(qst.answer) + 1
            qst.answer = newValue
            qst.answerJson = newValue
            setFieldValue && setFieldValue(qst.key, newValue);
            limitExtension = newValue
          } else {
            mc.error('Já atingiu a quantidade máxima de prorrogações.')
          }
        }
        return qst
      })

      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion == 1686) {
          if (limitExtension < 3) {
            const date = moment(qst.answer);
            const dataExtension = date.add(45, 'days');
            const dataExtensionField = dataExtension.format('DD/MM/YYYY');
            const dataExtensionFormat = dataExtension.format('YYYY-MM-DD');
            qst.answer = dataExtensionFormat;
            qst.answerJson = dataExtensionFormat;
            setFieldValue && setFieldValue(qst.key, dataExtensionField);
          }
        }
        return qst
      })
    }
  }

  if (question.idQuestion === 1832 && shareCapital?.length) {
    if (value?.idAnswerOption === 7419) {
      const isProjectQuestion = globalQuestionnaire.find(qst => qst.idQuestion === 1723);

      if (isProjectQuestion.idAnswerOption === 7336) {
        handleSPELimit({
          globalQuestionnaire,
          limits,
          setLimits,
          shareCapital,
          setFieldValue,
          modalitiesFeesData,
          scoreInformationData,
          modalities,
          setModalities,
          setQuestionnaireAnswersToDelete,
          questionnaireAnswersToDelete,
          useGetBorrowersInformationByLegalPersonIdsRequest,
          mc,
        });
      }
    } else if (value?.idAnswerOption === 7418) {
      const questionPEFIN = globalQuestionnaire.find(qst => qst.idQuestion === 1672);

      creditAnalysisInfoHandler.events.handleQuestionBlur({
        question: questionPEFIN,
        value: questionPEFIN.answer,
        questionnaireUpdated: globalQuestionnaire,
        setQuestionnaire,
        setFieldValue,
        limits,
        modalities,
        setModalities,
        modalitiesFeesData,
        scoreInformationData,
        setQuestionnaireAnswersToDelete,
        questionnaireAnswersToDelete,
        questionAnswersSERASA: null,
        globalQuestionnaire
      })
    }
  }

  if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
}

function handleQuestionBlur({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  modalities,
  setModalities,
  modalitiesFeesData,
  scoreInformationData,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {
  try {
    let saveFilteredQuestionnaire = false;

    if (question.idQuestion === 1680) {
      handleValidLimiteCalculado({
        questionnaire: questionnaireUpdated,
        setFieldValue,
        limitValueOverwrite: value
      })

      modalityHandler.events.handleModalities({
        questionnaire: questionnaireUpdated,
        modalitiesFeesData,
        scoreInformationData,
        modalities,
        setModalities,
        setFieldValue,
        questionnaireAnswersToDelete,
        setQuestionnaireAnswersToDelete,
        limitValueOverwrite: value
      });
    }

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("LIMITS - handleQuestionBlur error", e)
  }
}

function handleQuestionBlurCCG(
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue
) {
  try {
    if (question.idQuestion === 1684) {
      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion === 1684 && !value) {
          qst.answer = '0.00'
          qst.answerJson = '0.00'
          setFieldValue && setFieldValue(qst.key, '0.00');
        }

        return qst;
      })

      setQuestionnaire(questionnaireUpdated)
    }
  } catch (e) {
    console.log("LIMITS - handleQuestionBlur error", e)
  }
}

function handleLimits({
  questionnaire,
  limits,
  setFieldValue,
  operation = {}
}) {

  const limiteAprovadoValue = getLimiteAprovado({ questionnaire });

  limits.map((limit, limitIndex) => limit.map(qst => {
    if (limitIndex !== limits?.length - 1) return;

    if (qst.idQuestion === 1680) {
      qst.answer = limiteAprovadoValue;
      setFieldValue && setFieldValue(qst.key, String(qst.answer));
    }

    if (qst.idQuestion === 1685) {
      qst.answer = basicPeriod.currentDate().format("YYYY-MM-DD");
      setFieldValue && setFieldValue(qst.key, basicPeriod.currentDate().format("DD/MM/YYYY"));
    }

    if (qst.idQuestion === 1686) {
      qst.answer = basicPeriod.oneYearFromToday().format("YYYY-MM-DD");
      setFieldValue && setFieldValue(qst.key, basicPeriod.oneYearFromToday().format("DD/MM/YYYY"));

      const diffDays = dateDiffInDay(new Date(), new Date(basicPeriod.currentDate().format("YYYY-MM-DD")));
      qst.behaviorObject.fieldMinValue = diffDays + 2;
    }

    if (qst.idQuestion === 1687) {
      if (operation?.idDomainStatus === 416) {
        const answerOption = qst.answerOptions.find(q => q.idAnswerOption === 7407);

        const result = {
          idAnswerOption: answerOption?.idAnswerOption,
          dsAnswerOption: answerOption?.dsAnswerOption,
          resultValue: null
        };

        qst.answer = answerOption?.dsAnswerOption;
        qst.idAnswerOption = answerOption?.idAnswerOption;
        setFieldValue && setFieldValue(qst.key, result);
      }
      if (operation?.idDomainStatus === 439) {
        const answerOption = qst.answerOptions.find(q => q.idAnswerOption === 7286);
        const result = {
          dsAnswerOption: answerOption?.dsAnswerOption,
          idAnswerOption: answerOption?.idAnswerOption,
          resultValue: null
        };

        qst.answer = answerOption?.dsAnswerOption;
        qst.idAnswerOption = result.idAnswerOption;
        setFieldValue && setFieldValue(qst.key, result);
      }
    }
  }));

  return limiteAprovadoValue;
}

function handleLimiteCalculado({
  questionnaire,
  setFieldValue
}) {
  const qstSocialCapitalValue = questionnaire.find(v => v.idQuestion === 1637)?.answer;
  const qstSerasaCreditScoreValue = questionnaire.find(v => v.idQuestion === 1676)?.answer;
  const qstClassifCnaeSompoValue = questionnaire.find(v => v.idQuestion === 1708)?.answer;
  const qstRestritivosValue = questionnaire.find(v => v.idQuestion === 1716)?.answer;
  const qstCoefSegurancaValue = questionnaire.find(v => v.idQuestion === 1717)?.answer;
  const qstFaturamentoPresumido = questionnaire.find(v => v.idQuestion === 1671)?.answer;

  let qstCoefFaturamentoPresumido = 1;
  const qstCoefFaturamentoPresumidoQuestion = questionnaire.find(v => v.idQuestion === 1811);
  if (qstCoefFaturamentoPresumidoQuestion) {
    let idAnswerOption = qstCoefFaturamentoPresumidoQuestion.idAnswerOption || qstCoefFaturamentoPresumidoQuestion.behaviorObject.defaultValue;
    qstCoefFaturamentoPresumido = qstCoefFaturamentoPresumidoQuestion.answerOptions.find(ansOp => ansOp.idAnswerOption == idAnswerOption)?.behaviorObject?.resultValue;
  }

  //Fórmula: Limite Calculado = (Score Crédito Serasa (p1.43)/1000)^3*(CapitalSocial(p1.4)*ClassificaçãoCNAESOMPO(p1.49)*Restritivos(p1.46)*CoefSegurança (p1.50))+(CoefFaturamentoPresumido(p.1.53)*Faturamento Presumido(p1.38))
  const qstLimiteCalculado = questionnaire.find(v => v.idQuestion === 1718);
  if (qstLimiteCalculado) {
    qstLimiteCalculado.answer =
      (((qstSerasaCreditScoreValue / 1000) ** 3) * qstSocialCapitalValue * qstClassifCnaeSompoValue * qstRestritivosValue * qstCoefSegurancaValue) + (qstFaturamentoPresumido * qstCoefFaturamentoPresumido);


    qstLimiteCalculado.answer = ROUND(qstLimiteCalculado.answer, -4);

    setFieldValue && setFieldValue(qstLimiteCalculado.key, String(qstLimiteCalculado.answer));
    console.log('handleQuestionChange - handleLimiteCalculado - qstLimiteCalculado.answer', qstLimiteCalculado.answer,
      qstSerasaCreditScoreValue, qstSocialCapitalValue, qstClassifCnaeSompoValue, qstRestritivosValue, qstCoefSegurancaValue
    );

    handleValidLimiteCalculado({ questionnaire, setFieldValue, limitValueOverwrite: null })
  }
}

function handleValidLimiteCalculado({
  questionnaire,
  setFieldValue,
  limitValueOverwrite
}) {
  const qstLimiteCalculadoValue = limitValueOverwrite || questionnaire.find(v => v.idQuestion === 1718)?.answer;

  const qstValidLimiteCalculado = questionnaire.find(v => v.idQuestion === 1722);
  if (qstValidLimiteCalculado) {
    if (qstLimiteCalculadoValue < 20000) {
      qstValidLimiteCalculado.idAnswerOption = 7333;
      qstValidLimiteCalculado.answer = qstValidLimiteCalculado.answerOptions.find(v => v.idAnswerOption === 7333).dsAnswerOption;

    } else if (qstLimiteCalculadoValue >= 20000) {
      qstValidLimiteCalculado.idAnswerOption = 7334;
      qstValidLimiteCalculado.answer = qstValidLimiteCalculado.answerOptions.find(v => v.idAnswerOption === 7334).dsAnswerOption;

    }

    setFieldValue && setFieldValue(qstValidLimiteCalculado.key, qstValidLimiteCalculado.answer);
  }
}

function handleLimitsChange({
  limits,
  setLimits,
  setFieldValue,
}) {
  for (const [groupIndex, group] of limits?.entries() || []) {
    for (const qst of group) {
      const isLastGroup = groupIndex === limits?.length - 1;
      qst.disabled = false;
      if (!isLastGroup) qst.disabled = true;

      if (qst.idQuestion === 1680) {
        if (isLastGroup) qst.answer = limits[groupIndex - 1].find(q => q.idQuestion === 1680)?.answer;
        setFieldValue && setFieldValue(qst.key, qst.answer);
      } else if (qst.idQuestion === 1681) {
        if (isLastGroup) qst.answer = limits[groupIndex - 1].find(q => q.idQuestion === 1681)?.answer;
        setFieldValue && setFieldValue(qst.key, qst.answer);
      } else if (qst.idQuestion === 1682) {
        if (isLastGroup) qst.answer = limits[groupIndex - 1].find(q => q.idQuestion === 1682)?.answer;
        setFieldValue && setFieldValue(qst.key, qst.answer);
      } else if (qst.idQuestion === 1683) {
        if (isLastGroup) qst.answer = limits[groupIndex - 1].find(q => q.idQuestion === 1683)?.answer;
        setFieldValue && setFieldValue(qst.key, qst.answer);
      } else if (qst.idQuestion === 1688) {
        if (isLastGroup) qst.answer = limits[groupIndex - 1].find(q => q.idQuestion === 1688)?.answer;
        setFieldValue && setFieldValue(qst.key, qst.answer);
      } else if (qst.idQuestion === 1685 && !qst.answer) {
        qst.answer = basicPeriod.currentDate().format("YYYY-MM-DD");
        setFieldValue && setFieldValue(qst.key, basicPeriod.currentDate().format("DD/MM/YYYY"));
      } else if (qst.idQuestion === 1686) {
        const currentDate = basicPeriod.currentDate().format("YYYY-MM-DD");
        const oneYearFromToday = basicPeriod.oneYearFromToday();

        if (qst.answer) {
          if (qst.answer < currentDate) {
            setFieldValue && setFieldValue(qst.key, moment(qst.answer).format("DD/MM/YYYY"));
          } else {
            qst.answer = oneYearFromToday.format("YYYY-MM-DD");
            setFieldValue && setFieldValue(qst.key, oneYearFromToday.format("DD/MM/YYYY"));
          }
        } else {
          qst.answer = oneYearFromToday.format("YYYY-MM-DD");
          setFieldValue && setFieldValue(qst.key, oneYearFromToday.format("DD/MM/YYYY"));
        }

        const diffDays = dateDiffInDay(new Date(), new Date(basicPeriod.currentDate().format("YYYY-MM-DD")));
        qst.behaviorObject.fieldMinValue = diffDays + 2;
      } else if (qst.idQuestion === 1687) {
        const answerOption = qst.answerOptions.find(q => q.idAnswerOption === (!isLastGroup ? 7354 : 7407));
        const result = {
          dsAnswerOption: answerOption?.dsAnswerOption,
          idAnswerOption: answerOption?.idAnswerOption,
          resultValue: null
        };

        qst.answer = answerOption?.dsAnswerOption;
        qst.idAnswerOption = result.idAnswerOption;
        setFieldValue && setFieldValue(qst.key, result);
      }
    }

    setLimits(limits)
  }
}

function getLimiteAprovado({
  questionnaire
}) {
  const qstScore = questionnaire.find(v => v.idQuestion === 1676)?.answer;
  const qstLimiteCalculadoValue = questionnaire.find(v => v.idQuestion === 1718)?.answer;
  const qstLimiteMaximoAutomaticoValue = questionnaire.find(v => v.idQuestion === 1719)?.answer;
  const qstLimiteMaximo600a900Value = questionnaire.find(v => v.idQuestion === 1720)?.answer;
  const qstLimiteMaximo900Value = questionnaire.find(v => v.idQuestion === 1721)?.answer;

  return Math.min(
    +qstLimiteCalculadoValue,
    +qstLimiteMaximoAutomaticoValue,
    +qstScore <= 900 ? +qstLimiteMaximo600a900Value : +qstLimiteMaximo900Value);
}

function dateDiffInDay(date1, date2) {
  const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

  return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
}

async function handleSPELimit({
  globalQuestionnaire,
  limits,
  setLimits,
  shareCapital,
  setFieldValue,
  modalitiesFeesData,
  scoreInformationData,
  modalities,
  setModalities,
  setQuestionnaireAnswersToDelete,
  questionnaireAnswersToDelete,
  useGetBorrowersInformationByLegalPersonIdsRequest,
  mc,
  adhocToValidate = false,
}) {
  let minEconomicGroupLimitValueCalculated = 0;

  const shareCapitalLegalPersonIds = shareCapital.map(group => group.find(qst => qst.idQuestion === 1825)?.answer).filter((legalPersonId) => legalPersonId.length === 14);

  const borrowerLegalPersonId = globalQuestionnaire.find(qst => qst.idQuestion === 1634)?.answer;

  if (shareCapitalLegalPersonIds.includes(borrowerLegalPersonId)) {
    if (!adhocToValidate) {
      setModalities(prev=> [prev[0]]);
    }

    mc.error(`O CNPJ do tomador (${borrowerLegalPersonId}) não pode ser igual ao CNPJ de um dos sócios.`);
    return false
  }

  if (!shareCapitalLegalPersonIds?.length) {
    if (!adhocToValidate) {
      setModalities(prev=> [prev[0]]);
    }

    mc.error(`Não há sócios para cálculo do Limite Aprovado de SPE com Limite Compartilhado.`);
    return true
  }

  const { data: shareCapitalLimitsInfoResponse } = await useGetBorrowersInformationByLegalPersonIdsRequest(null, { legalPersonIds: shareCapitalLegalPersonIds });

  if (shareCapitalLimitsInfoResponse.statusCode != 200) {
    if (!adhocToValidate) {
      setModalities(prev=> [prev[0]]);
    }

    mc.error(`Não foi possível obter as informações de Limite Aprovado dos Grupos Econômicos.`);
    return false
  };

  const shareCapitalInfo = shareCapitalLimitsInfoResponse.value;

  if (!shareCapitalInfo?.length) {
    if (!adhocToValidate) {
      setModalities(prev=> [prev[0]]);
    }

    mc.error(`Para cálculo do Limite Aprovado de SPE com Limite Compartilhado, é necessário que todos os Grupos Econômicos tenham Analise de Crédito e Limite Aprovado. 
      Favor realizar o cadastro e recalcular o Limite da SPE.`);
    return false
  }

  const someBorrowerHasNoLimit = shareCapitalInfo.some(borrower => !borrower?.borrowerInfo || !borrower?.borrowerInfo?.globalFinanceBalanceDebitAmount);

  if (someBorrowerHasNoLimit) {
    if (!adhocToValidate) {
      setModalities(prev=> [prev[0]]);
    }

    mc.error(`Para cálculo do Limite Aprovado de SPE com Limite Compartilhado, é necessário que todos os Grupos Econômicos tenham Analise de Crédito e Limite Aprovado. 
      Favor realizar o cadastro e recalcular o Limite da SPE.`);
    return false
  };

  for (const borrower of shareCapitalInfo) {
    const selectedShareCapitalGroup = shareCapital.find(group =>
      group.find(question => question.idQuestion === 1825 && question.answer == borrower.legalPersonId)
    );

    if (!selectedShareCapitalGroup) {
      if (!adhocToValidate) {
        setModalities(prev=> [prev[0]]);
      }

      mc.error(`Para cálculo do Limite Aprovado de SPE com Limite Compartilhado, é necessário que todos os Grupos Econômicos tenham Analise de Crédito e Limite Aprovado. 
        Favor realizar o cadastro e recalcular o Limite da SPE.`);
      return false
    };

    const shareCapitalConsumption = selectedShareCapitalGroup.find((question) => question.idQuestion === 1828)?.answer;

    if (!shareCapitalConsumption || shareCapitalConsumption == 0) {
      if (!adhocToValidate) {
        setModalities(prev=> [prev[0]]);
      }

      mc.error(`O sócio ${borrower.legalPersonId} informado na composição social não possui percentual de participação.`);
      return false
    }

    const borrowerLimit = borrower?.borrowerInfo?.globalFinanceBalanceDebitAmount

    const economicGroupLimitValueCalculated = Number(borrowerLimit) / Number(shareCapitalConsumption) * 100;

    if (minEconomicGroupLimitValueCalculated === 0 || economicGroupLimitValueCalculated < minEconomicGroupLimitValueCalculated) {
      minEconomicGroupLimitValueCalculated = economicGroupLimitValueCalculated;
    }
  }

  if (adhocToValidate) return true

  setLimits(limits.map((limit, limitIndex) => limit.map(qst => {
    if (limitIndex !== limits?.length - 1) return qst;

    if (qst.idQuestion === 1680) {
      qst.answer = minEconomicGroupLimitValueCalculated || '';
      setFieldValue && setFieldValue(qst.key, String(qst.answer));
    }

    return qst;
  })));

  modalityHandler.events.handleModalities({
    questionnaire: globalQuestionnaire,
    modalitiesFeesData,
    scoreInformationData,
    modalities,
    setModalities,
    setFieldValue,
    setQuestionnaireAnswersToDelete,
    questionnaireAnswersToDelete,
    limitValueOverwrite: minEconomicGroupLimitValueCalculated || ''
  });

  mc.success(`Limite Aprovado de SPE com Limite Compartilhado calculado com sucesso.`);
}

const basicPeriod = {
  /** TODO: remove subtract */
  currentDate: () => moment(new Date())/*.subtract(6, 'M')*/,
  oneYearFromToday: () => moment(new Date()).add(1, 'y'),
  isExpiredFromToday: (date) => moment(new Date(date).toISOString().slice(0, 10)).diff(moment(new Date()), 'days') <= -1,
  isValidPeriod: (date1, date2) => {
    try {
      if (date1 && date2) return moment(new Date(date2).toISOString().slice(0, 10)).diff(new Date(date1).toISOString().slice(0, 10), 'days') >= 0;
      return false;
    } catch (e) {
      return true
    }
  },
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleQuestionBlurCCG,
  handleLimits,
  handleLimiteCalculado,
  handleValidLimiteCalculado,
  handleLimitsChange,
  getLimiteAprovado,
  handleSPELimit,
  dateDiffInDay,
}

export { events };
